module.exports = __webpack_public_path__ + "static/media/react_logo.ab194d54.png";